(() => {
  const warmSecondImage = (gallery) => {
    if (!gallery || gallery.dataset.bugaSecondImageReady === 'true') return;
    const images = gallery.querySelectorAll('slideshow-slide img');
    const second = images[1];
    if (!second) return;

    gallery.dataset.bugaSecondImageReady = 'true';
    second.loading = 'eager';

    const preload = new Image();
    if (second.srcset) preload.srcset = second.srcset;
    if (second.sizes) preload.sizes = second.sizes;
    preload.src = second.currentSrc || second.src;
    if (typeof second.decode === 'function') second.decode().catch(() => {});
  };

  const init = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const galleries = document.querySelectorAll('.product-card .card-gallery');
    if (!galleries.length) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          warmSecondImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '500px 0px' });
      galleries.forEach((gallery) => observer.observe(gallery));
    } else {
      galleries.forEach(warmSecondImage);
    }

    galleries.forEach((gallery) => gallery.addEventListener('pointerenter', () => warmSecondImage(gallery), { passive: true, once: true }));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
